import { wordService } from "../services/wordService";

export const applyParagraph = () => wordService.applySemanticTag({ type: "paragraph" });
